import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
import { url } from "../../../Constant";
import { useAuth } from "../../../Context/AuthProvider";
import { useEffect } from "react";
import { useState } from "react";
import $ from "jquery";
import { toast } from "react-toastify";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const NewDepartment = () => {
  const { auth } = useAuth();
  const [groups, setGroups] = useState();
  const [newGroup, setNewGroup] = useState();
  const [groupError, setGroupError] = useState("");
  const [errorEnable, setErrorEnable] = useState(false);
  const [alreadyCalled, setAlreadyCalled] = useState(false);
  const [loader, setLoader] = useState(false);
  const getGroups = () => {
    axios
      .post(
        url + "/get-groups",
        {
          package_id: auth.package_id,
          template_name: auth.package_id,
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            // console.log(response.data.data )
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setGroups([]);
            } else if (response.data.message === "Data Found") {
              setGroups(response.data.data);
              // console.log('umair', response.data.data.number_of_depart);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleDropDown = () => {
    let result = "";

    result = groups?.group_drop_down.map((response, index) => (
      <option value={response.group_name} key={index}>
        {response.group_name}
      </option>
    ));
    // if (alreadyCalled === true) {
    setTimeout(() => {
      setValues();
    }, 1000);
    // }
    return result;
  };

  const setValues = () => {
    setAlreadyCalled(true);
    if (alreadyCalled !== true) {
      for (let i = 0; i < groups?.groups?.length; i++) {
        $(`#group${i}`).val(groups?.groups[i].group_name);
      }
    }
  };

  useEffect(() => {
    // groups?.packages[0]?.number_of_depart;
    var temp = [];
    for (let i = 0; i < groups?.number_of_depart; i++) {
      temp.push({
        id: i,
      });
    }
    setNewGroup(temp);
  }, [groups]);
  // const handleTable = () => {
  //   let result = "";
  //   let index = 1;
  //   let classRef = this;
  //   // result =
  //   if (groups?.length > 0) {
  //     result = groups?.groups.map((response, index) => (
  //       <div key={index}>
  //         <div className="uk-width-1-2@m uk-margin-top">
  //           <input
  //             className="uk-input"
  //             type="text"
  //             // placeholder="Enter department name..."
  //             aria-label="Input"
  //             disabled
  //             value={index + 1}
  //           />
  //         </div>

  //         <div className="uk-width-1-2@m uk-margin-top">
  //           <label>Department number</label>
  //           <select id={`group${index}`}>{handleDropDown()}</select>
  //         </div>
  //       </div>
  //     ));
  //   } else {
  //     if (groups?.packages[0].number_of_depart != 0) {
  //       let dataForGroup = [];
  //       for (let i = 0; i < groups?.packages[0]?.number_of_depart; i++) {
  //         dataForGroup.push({
  //           id: i,
  //         });
  //       }
  //       result = dataForGroup.map((_, index) => (
  //         <div key={index}>
  //           <div className="uk-width-1-2@m uk-margin-top">
  //             <input
  //               className="uk-input"
  //               type="text"
  //               placeholder="Enter department name..."
  //               aria-label="Input"
  //               value={index + 1}
  //             />
  //           </div>

  //           <div className="uk-width-1-2@m uk-margin-top">
  //             <label>Department number</label>
  //             <select id={`group${index}`}>{handleDropDown()}</select>
  //           </div>
  //         </div>
  //       ));
  //     } else {
  //       let defaultData = [{ id: 0 }, { id: 1 }, { id: 2 }];
  //       result = defaultData.map((_, index) => (
  //         <div key={index}>
  //           <div className="uk-width-1-2@m uk-margin-top">
  //             <input
  //               className="uk-input"
  //               type="text"
  //               placeholder="Enter department name..."
  //               aria-label="Input"
  //               value={index + 1}
  //             />
  //           </div>

  //           <div className="uk-width-1-2@m uk-margin-top">
  //             <label>Department number</label>
  //             <select id={`group${index}`}>{handleDropDown()}</select>
  //           </div>
  //         </div>
  //       ));
  //     }
  //   }
  //   return result;
  // };
  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("department", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getGroups();
  }, []);

  const updateGroups = () => {
    setErrorEnable(true);
    setLoader(true);
    let group_name = [];
    let group_id = "";

    if (groups?.group_drop_down.length > 0 && groups?.groups.length > 0) {
      group_id = groups?.groups.map((val, index) => {
        group_name.push($(`#group${index}`).val());
      });
    } else {
      if (groups?.number_of_depart != 0) {
        for (let i = 0; i < groups?.number_of_depart; i++) {
          group_name.push($(`#group${i}`).val());
        }
      }
      // else {
      //   group_name.push(
      //     $("#group0").val(),
      //     $("#group1").val(),
      //     $("#group2").val()
      //   );
      // }
    }
    let api = "";
    if (auth.role === "2") {
      api = "user-store-group";
    } else {
      api = "store-group";
    }
    axios
      .post(
        url + api,
        {
          group_name: group_name,
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200 && response.status === 200) {
          setLoader(false);
          toast.success("Department updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
          setTimeout(() => {
            window.location.href = "/vpbx-manager";
          }, 2000);
          setGroupError("");
        } else {
          setGroupError("Groups should be unique");
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-1-1">
              <div className="dashboardIntro">
                <Link to="/vpbx-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>Sequence Department</h3>
                <p>
                  Sequence a Department can help admins quickly assign the same
                  products to a group of users.
                </p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Department information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Department name</label>
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Department number</label>
                </div>

                {groups?.number_of_depart > 0 &&
                  groups?.groups?.map((val, index) => {
                    return (
                      <>
                        {/* <div key={index}> */}
                        {/* <div className="uk-width-1-2@m uk-margin-top"> */}
                        <div className="uk-width-1-2@m uk-margin-top">
                          {index + 1}
                        </div>

                        <div className="uk-width-1-2@m uk-margin-top">
                          {/* <label>Department number</label> */}
                          <select className="uk-select" id={`group${index}`}>
                            {handleDropDown()}
                          </select>
                        </div>
                        {/* </div> */}
                      </>
                    );
                  })}
                {groups?.groups.length === 0 &&
                  newGroup?.map((val, index) => {
                    return (
                      <>
                        <div className="uk-width-1-2@m uk-margin-top">
                          {index + 1}
                        </div>

                        <div className="uk-width-1-2@m uk-margin-top">
                          <select id={`group${index}`}>
                            {handleDropDown()}
                          </select>
                        </div>
                      </>
                    );
                  })}
                {/* <div className="uk-width-1-2@m uk-margin-top">
                  <label>Description <span className='uk-float-right'>(optional)</span></label>
                  <textarea className="uk-textarea" rows="5" placeholder="" aria-label="Textarea"></textarea>
                </div> */}
                {setGroupError !== "" && errorEnable && (
                  <div className="formErrors">{groupError}</div>
                )}
                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button className="pinkBtn" onClick={updateGroups}>
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewDepartment;
